import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonCommonModule } from '../common/components/common.module';
import { ChatComponent } from './components/chat/chat.component';

@NgModule({
  declarations: [ChatComponent],
  exports: [ChatComponent],
  imports: [CommonModule, SkeletonCommonModule]
})
export class ChatModule {}
